<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-6 bg-gradient-success">
      <div class="accordion" role="tablist">
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <h3 class="card-title"><b-button size="sm" v-b-toggle.accordion-1 variant="info"><i class="fa fa-filter"></i></b-button>Filtros </h3>
            
          </b-card-header>
          <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <!--b-card-text>I start opened because <code>visible</code> is <code>true</code></b-card-text>
              <b-card-text>{{ text }}</b-card-text>-->
              <b-row>
                <b-col sm="3">
                    <select name="tiendaId" v-on:change="onChangeSelectCajas" v-model="filtro.tiendaId" id="tiendaId" class="form-control form-control-sm" :class="{ 'is-invalid': filtro.errors.has('tiendaId') }">
                        <option value="-1">Todas las Tiendas</option>
                        <option v-for="itemc in selectTienda" :value="itemc.value"  v-bind:key="itemc.value">
                            {{itemc.text}}
                        </option>
                    </select> 
                </b-col>
                <b-col sm="3">
                    <select name="cajaId" v-on:change="onFiltroChange" v-model="filtro.cajaId" id="cajaId" class="form-control form-control-sm">
                        <option selected value="0">Todos las Cajas</option>
                        <option v-for="itemc in cajasSelect" :value="itemc.id"  v-bind:key="itemc.id">
                            {{itemc.codigoCaja}}
                        </option>
                    </select>
                </b-col>
                <b-col sm="3">
                    <select name="estatus" v-on:change="onFiltroChange" v-model="filtro.estatus" id="estatus" class="form-control form-control-sm">                        
                        <option value="false">Inactivo</option>
                        <option value="true">Activo</option>                                
                    </select>                </b-col>
                <b-col sm="3" class="text-center">
                        <b-button title="Aplicar filtro" :class="{'btn btn-success' :filtroActivo, 'btn btn-light':!filtroActivo}" @click="aplicarFiltro()"><i :class="{'fas fa-check':filtroActivo,'fas fa-ban':!filtroActivo}"></i></b-button>
                        <b-button title="Resetear filtro" variant="primary" @click="resetFiltro()"><i class="fas fa-undo"></i></b-button>
                </b-col>
              </b-row>
              <b-row>
                  <b-col sm="3">
                    <select name="areaId" v-on:change="onFiltroChange" v-model="filtro.areaId" id="areaId" class="form-control form-control-sm">
                        <option selected value="-1">Todas las Areas</option>
                        <option v-for="itemc in areasSelect" :value="itemc.value"  v-bind:key="itemc.value">
                            {{itemc.text}}
                        </option>
                    </select> 
                  </b-col>
                  <b-col sm="3">
                    <b-form-input size="sm" id="fechaF" type="date" v-on:change="onFiltroChange" v-model="filtro.fechaF" name="fechaF" min="01-01-2000"
                max="31-12-3000"></b-form-input>
                  </b-col>
                  <b-col sm="3">
                    <b-input-group size="sm" prepend="Consecutivo">
                      <b-form-input size="sm" id="consecutivo" type="number" v-on:change="onFiltroChange" v-model="filtro.consecutivo" value="" placeholder="00000000"></b-form-input>
                    </b-input-group>
                  </b-col>                                                                       
              </b-row>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
    </base-header>
    <b-container fluid class="mt--7">
      <b-row>
        <b-col>
          <b-card no-body>
              <b-card-header class="border-0">
                  <h3 class="mb-0">Administración de Cajas</h3>
                  <div class="text-right">
                  <base-button size="md"
                      body-class="text-left"
                      v-b-popover.hover.top="'Nueva Caja'"
                      type="success"
                      @click="newCaja()"
                      >
                      <i class="fas fa-save"></i>
                  </base-button>
                  </div>                  
              </b-card-header>
              <div class="card-body table-responsive p-0">
                      <table class="table table-hover">
                        <tbody>
                          <tr class="thead-light">
                              <th>Cod. Caja</th>
                              <th>Consecutivo</th>
                              <th>Fact. Al Mayor</th>
                              <th>Tienda</th>
                              <th>Área</th>
                              <th>Estatus</th>                        
                              <th>Acciones</th>
                        </tr>
                        <tr v-for="caja in cajas" :key="caja.id">
                          <td>{{caja.codigoCaja}}</td>
                          <td>{{zfill(caja.consecutivo, 6)}}</td>
                          <td><span :class="{'badge badge-danger':!caja.facturaAlMayor, 'badge badge-success':caja.facturaAlMayor }">{{caja.facturaAlMayor | factmy}}</span></td>
                          <td>{{caja.tiendaNombre}}</td>
                          <td>{{caja.areaNombre}}</td>
                          <td><span :class="{'badge badge-danger':!caja.estatus, 'badge badge-success':caja.estatus }">{{caja.estatus | status}}</span></td>                    
                          <td>
                              <!--<base-button size="sm" type="secondary"
                                v-b-popover.hover.top="'Detalle Caja'"                         
                                @click="detalleCaja(caja)"
                                :class="{'disabled':(caja.estatus == -1 || caja.estatus == 0)}">
                                <i class="fa fa-file-invoice-dollar"></i>
                              </base-button>-->                        
                              <base-button size="sm" type="warning" v-b-popover.hover.top="'Editar Caja'"   @click="editModal(caja)">
                                <i class="fa fa-edit"></i>
                              </base-button>                        
                              <base-button size="sm" type="danger" v-b-popover.hover.top="'Inabilitar Caja'"  @click="deletecaja(caja.id)">
                                <i class="fa fa-trash"></i>
                              </base-button>

                          </td>
                        </tr>
                      </tbody></table>
                  
                    <!-- /.card-body 
                    <div class="card-footer">
                        <pagination :data="cajas" @pagination-change-page="getResults"></pagination>
                    </div>
              -->
                  <!-- /.card -->
              </div>
              <b-card-footer class="py-4 d-flex justify-content-end">
                  <base-pagination @change="getResults"  v-model="currentPage" :per-page="perPage" :total="totalItemsRow"></base-pagination>
              </b-card-footer>
          </b-card>          
          <!--<light-table/>          
          <dark-table/>-->
        </b-col>
      </b-row>
      <div class="mt-5"></div>     
    </b-container>


    <!-- Modal -->
    <b-modal ref="modal-1" size="lg" centered title="Caja" hide-footer>
        <template #modal-title>
            <h5 class="modal-title" v-show="!editmode" id="addNewLabel">Guardar Caja</h5>
            <h5 class="modal-title" v-show="editmode" id="addNewLabel">Actualizar Caja</h5>
        </template>
          <form @submit.prevent="editmode ? updateCaja() : createCaja()">
            <div class="modal-body">
              <div class="container">
                <h6 class="heading-small text-muted mb-4">Información de Caja</h6>
                <div class="pl-lg-4">
                  <b-row>
                    <b-col lg="4">
                      <base-input
                        required       
                        type="text"
                        label="Código Caja"
                        placeholder="Ej. 001"                        
                        v-model="form.codigoCaja"
                      >
                      </base-input>
                    </b-col>
                    <b-col lg="4">
                      <base-input
                        required
                        type="text"
                        label="Consecutivo"
                        placeholder="Ej. 11"
                        v-model="form.consecutivo"
                      >
                      </base-input>
                    </b-col>
                    <b-col lg="4">
                      <base-input
                        required
                        type="text"
                        label="VTID"
                        placeholder="Ej. 00001"
                        v-model="form.vtid"
                      >
                      </base-input>
                    </b-col>                    
                  </b-row>
                  <b-row>
                    <b-col lg="4">
                      <base-input
                        required       
                        type="text"
                        label="Serial Impresora"
                        placeholder="Ej. 0000001"                        
                        v-model="form.serialImpresora"
                      >
                      </base-input>
                    </b-col>
                    <b-col lg="4">
                      <label class="form-control-label" for="select-fact-may">Factura al Mayor</label>
                      <b-form-select 
                        id="select-fact-may"
                        v-model="form.facturaAlMayor" :options="factMayor">
                      </b-form-select>                      
                      <!--<base-input
                        required
                        type="text"
                        label="Factura al Mayor"
                        placeholder="Ej. 11"
                        v-model="form.facturaAlMayor"
                      >
                      </base-input>-->
                    </b-col>
                    <b-col lg="4">
                      <label class="form-control-label" for="select-agaveta">Abrir Gaveta</label>
                      <b-form-select 
                        id="select-agaveta"
                        v-model="form.abrirGaveta" :options="factMayor">
                      </b-form-select>
                      <!--<base-input
                        required
                        type="text"
                        label="Estatus"
                        placeholder="Ej. 00001"
                        v-model="form.estatus"
                      >
                      </base-input>-->
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col lg="4">
                      <label class="form-control-label" for="select-tienda">Tienda</label>
                      <b-form-select 
                        id="select-tienda"
                        v-on:change="onChangeTienda"
                        v-model="form.tiendaId" :options="selectTienda">
                      </b-form-select>                       
                      <!--<base-input
                        required       
                        type="text"
                        label="Serial Impresora"
                        placeholder="Ej. 0000001"                        
                        v-model="form.serialImpresora"
                      >
                      </base-input>-->
                    </b-col>
                    <b-col lg="4">
                      <label class="form-control-label" for="select-area">Área</label>
                      <b-form-select 
                        id="select-area"
                        v-model="form.areaId" :options="areas">
                      </b-form-select>                      
                      <!--<base-input
                        required
                        type="text"
                        label="Factura al Mayor"
                        placeholder="Ej. 11"
                        v-model="form.facturaAlMayor"
                      >
                      </base-input>-->
                    </b-col>
                    <b-col lg="4">
                      <label class="form-control-label" for="select-estatus">Estatus</label>
                      <b-form-select 
                        id="select-estatus"
                        v-model="form.estatus" :options="status">
                      </b-form-select>
                      <!--<base-input
                        required
                        type="text"
                        label="Estatus"
                        placeholder="Ej. 00001"
                        v-model="form.estatus"
                      >
                      </base-input>-->
                    </b-col>                    
                  </b-row>                  
                </div>                
                <hr class="my-3">                
                <h6 class="heading-small text-muted mb-4">Puertos</h6>
                <div class="pl-lg-4">
                  <b-row >
                    <b-col lg="4">
                      <base-input
                        type="text"
                        label="Puerto Balanza"
                        placeholder="Ej. Com2"
                        v-model="form.puertoBalanza"
                      >
                      </base-input>
                    </b-col>
                    <b-col lg="4">
                      <base-input
                        type="text"
                        label="Puerto Cód. Barra"
                        placeholder="Ej. Com1"
                        v-model="form.puertoCodigoBarra"
                      >
                      </base-input>
                    </b-col>
                    <b-col lg="4">
                      <base-input
                        type="text"
                        label="Puerto Impresora"
                        placeholder="Ej. Com3"
                        v-model="form.puertoImpresora"
                      >
                      </base-input>
                    </b-col>                    
                  </b-row>
                  </div>
              </div>
            </div>
           
            <div class="modal-footer">
              <b-button size="sm" type="button" class="btn btn-danger" @click="hideModal" >Cerrar</b-button>
              <b-button size="sm" v-show="editmode" type="submit" class="btn btn-success">Actualizar</b-button>
              <b-button size="sm" v-show="!editmode" type="submit" class="btn btn-primary">Guardar</b-button>
            </div>
          </form>
    </b-modal>
    <!-- Detalle pago -->
    <b-modal ref="modal-Detalle" hide-backdrop content-class="shadow" size="lg" centered title=" Detalles de Pago">

      <table cellspacing="0" cellpadding="0">
        <col width="80" span="3" />
        <tr>
          <td colspan="2" width="160"><badge type="default">Pago Electronico: </badge></td>
          <td width="80">{{detallespago.pagoElectronico.total | moneda}}</td>
        </tr>
        <tr>
          <td></td>
          <td>TDD</td>
          <td>{{detallespago.pagoElectronico.tdd | moneda}}</td>
        </tr>
        <tr>
          <td></td>
          <td>TDC</td>
          <td>{{detallespago.pagoElectronico.tdc | moneda}}</td>
        </tr>
       <hr class="my-3">
        <tr>
          <td>Efectivo</td>
          <td></td>
          <td>{{detallespago.efectivo.total | moneda}}</td>
        </tr>
        <tr>
          <td></td>
          <td>Dolar</td>
          <td>{{detallespago.efectivo.dolar | moneda}}</td>
        </tr>
        <tr>
          <td></td>
          <td>Bs</td>
          <td>{{detallespago.efectivo.bs | moneda}}</td>
        </tr>
<hr class="my-3">
        <tr>
          <td>Otros</td>
          <td></td>
          <td>{{detallespago.otros.total | moneda}}</td>
        </tr>
        <tr>
          <td></td>
          <td>Zelle</td>
          <td>{{detallespago.otros.zelle | moneda}}</td>
        </tr>
        <tr>
          <td></td>
          <td>Wallet Rio</td>
          <td>{{detallespago.otros.wallet | moneda}}</td>
        </tr>
        <tr>
          <td></td>
          <td>Paypal</td>
          <td>{{detallespago.otros.paypal | moneda}}</td>
        </tr>
        <tr>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td>Total</td>
          <td>{{detallespago.totalGeneral | moneda}}</td>
        </tr>
        <tr>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      </table>
      <template #modal-footer="{ close }">
        <div class="w-100">          
          <b-button
            variant="primary"
            size="sm"
            class="float-right"
            @click="close()"
          >
            Cerrar
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
  import { Dropdown, DropdownItem, DropdownMenu, Table, TableColumn } from 'element-ui';

  import projects from './../../Tables/projects'
  import detallespago from './../../Tables/detallespago'  
  //import LightTable from "./../../Tables/RegularTables/LightTable";
  //import DarkTable from "./../../Tables/RegularTables/DarkTable";

  export default {
    components: {
      //LightTable,
      //DarkTable,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn
    },
    data() {
      return {
      editmode: false,
      filtroActivo:false,
      selectEdo:{},
      tiendas: [],
      areas: [],
      cajas:[],
      perPage:10,
      currentPage: 1,
      totalItemsRow:10,
      form: new Form({
        id: 0,
        tiendaId: '',
        codigoCaja: '',
        consecutivo: '',
        puertoBalanza: '',
        puertoCodigoBarra: '',
        puertoImpresora: '',
        serialImpresora: '',
        vtid: '',
        areaId: '',
        abrirGaveta: true,
        facturaAlMayor: true,
        estatus: true
      }),
      filtro: new Form({
        codCaja:'',
        cajaId:0,
        areaId:-1,
        tiendaId:-1,
        consecutivo:0,
        estatus:true
      }),              
        projects,
        detallespago,
        status: [{value:true, text:"Activo"}, {value:false, text:"Inactivo"}],
        factMayor: [{value:true, text:"Si"}, {value:false, text:"No"}],
        selectTienda:[],
        cajasSelect:[],
        areasSelect:[]
      };
    },
    methods: {
      async getResults(page = 1) {
        await axios.get(this.$gate.getApiUrl()+'Caja?page='+page+'&perPage='+this.perPage,{ params: this.filtro })
        .then(({ data }) => {
          if(data){
            this.cajas = data.cajas;
            this.totalItemsRow = data.totalrow;
          }else{
            this.cajas =[];
          }
        }).catch( e => {
            /* si el token es invalido o esta vencido */
            if (e.response.status == 401) {
               this.$gate.removeLogin();
               this.$router.push("/Login");             
            }
        });
      },      
      detalleCaja(caja){
        this.$refs['modal-Detalle'].show();
      },
      newCaja(){
        this.editmode = false;
        this.form.reset();
        this.$refs['modal-1'].show();        
      },      
      editModal(caja){
        this.editmode = true;
        this.form.reset();        
        this.$refs['modal-1'].show();       
        this.form.fill(caja);
        this.onChangeTienda();
      },
      hideModal() {
        this.$refs['modal-1'].hide();
      },
      createCaja(){
        this.form.post(this.$gate.getApiUrl()+'Caja', this.form)
          .then(() => {
            // success            
            this.$refs['modal-1'].hide();

            this.$swal({
              title: 'Caja Creada Exitosamente!!',
              icon: 'success',
              showConfirmButton: false,
              toast: true,
              position: 'top-end',
              timer: 3000
            })
            Fire.$emit('AfterCreate');
            this.hideModal();
          //this.$Progress.finish();
        })
        .catch((e) => {
          if (e.response.status == 400) {  
            this.$swal(
                  '',
                  e.response.data.message,
                  'error'
            )
          }

          //this.$Progress.fail();
        });
      },
      aplicarFiltro(){
        //if(this.$gate.isAdmin()){
          let loader = this.$loading.show({
            // Optional parameters
            container: this.fullPage ? null : this.$refs.formContainer,
            canCancel: true,
            loader: 'dots',
          });
          this.getResults();
          loader.hide();     
      },       
      resetFiltro(){
        this.filtro.reset();      
        this.filtroActivo = false;
        //this.loadUsuariosPos();
      },      
      onFiltroChange(){
        this.filtroActivo = true;
        //console.log(this.filtro)
        //this.onChangeSelectCajas();
      },      
      async onChangeSelectCajas(){
        this.filtroActivo = true;
        await axios.get(this.$gate.getApiUrl()+"Caja/tienda/"+this.filtro.tiendaId).then(({ data }) => {this.cajasSelect = data;/*this.getSelectTienda();*/ }); 
        await axios.get(this.$gate.getApiUrl()+"Area/GetSelectArea/"+this.filtro.tiendaId).then(({ data }) => {this.areasSelect = data;/*this.getSelectTienda();*/ }); 

      },      
      getArea(areaId){
        if(this.areas.length >0){
          let itemEnc = this.areas.find(m => m.value === areaId);
          if(areaId>=0){
            return itemEnc.text;
          }else{ 
            return "---";
          }
        }
      },
      onChangeTienda(){        
        //if(this.form.tiendaId!=""){
          axios.get(this.$gate.getApiUrl()+"Area/GetSelectArea/"+this.form.tiendaId).then(({ data }) => {this.areas = data; this.areas.push({value:"", text:"Seleccione"})});
        //}
      },
      getTienda(tiendaId){
        
        if(this.tiendas.length >0){
          let itemEnc = this.tiendas.find(m => m.id === tiendaId);
          if(tiendaId>=0){
            return itemEnc.nombre;
          }else{ 
            return "---";
          }
        }
      },
      getSelectTienda(){
        this.tiendas.forEach(element => {
          let data = {value:element.id, text:element.nombre};
          this.selectTienda.push(data);          
        });
      },
      zfill(number, width=6) {
          var numberOutput = Math.abs(number); /* Valor absoluto del número */
          var length = number.toString().length; /* Largo del número */ 
          var zero = "0"; /* String de cero */  
          
          if (width <= length) {
              if (number < 0) {
                  return ("-" + numberOutput.toString()); 
              } else {
                  return numberOutput.toString(); 
              }
          } else {
              if (number < 0) {
                  return ("-" + (zero.repeat(width - length)) + numberOutput.toString()); 
              } else {
                  return ((zero.repeat(width - length)) + numberOutput.toString()); 
              }
          }
      },
      updateCaja(){
        this.$Progress.start()
        this.form.put(this.$gate.getApiUrl()+'Caja/'+this.form.id)
          .then(() => {
            // success
            this.$refs['modal-1'].hide();
            this.$swal(
            'Actualizado!',
            'Registro Actualizado!.',
            'success'
          )
          this.$Progress.finish();
          Fire.$emit('AfterCreate');
        })
        .catch((e) => {
          //console.log(e)

          this.$Progress.fail();
        });
      },
      loadCajas: async function(){
        //if(this.$gate.isAdminOrAuthor()){
          
          //await axios.get(this.$gate.getApiUrl()+'Caja').then(({ data }) => {this.cajas = data; });
          this.getResults();
          await axios.get(this.$gate.getApiUrl()+'Tienda').then(({ data }) => {this.tiendas = data; this.getSelectTienda(); });
          
        //}
      },

    },
    created(){
      this.loadCajas();
      Fire.$on('AfterCreate',() => {
        this.getResults();
      });       
    }
  };
</script>
<style>
.table .thead-light th {
    background-color: #f5f5f5;/*#0a0a0a;*/
    color: #333;
    font-size: 14px;
}
.table th, .table td {
    padding: 1rem;
    vertical-align: top;
    border-top: 1px solid #e9ecef;
}
</style>
